module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n            Hapus Pembayaran\n        ")]), _vm._v(" "), _c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "Ketik Marking",
      "filterable": "",
      "clearable": "",
      "remote": "",
      "remote-method": _vm.getMarkingByCode,
      "loading": _vm.loadingGetMarking
    },
    on: {
      "on-change": _vm.getPayment
    },
    model: {
      value: (_vm.markingIdSelected),
      callback: function($$v) {
        _vm.markingIdSelected = $$v
      },
      expression: "markingIdSelected"
    }
  }, _vm._l((_vm.optionMarkings), function(option, index) {
    return _c('Option', {
      key: index,
      attrs: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.label))])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('Table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.payments.length > 0),
      expression: "payments.length > 0"
    }],
    attrs: {
      "columns": _vm.tableColumns,
      "data": _vm.payments,
      "no-data-text": ""
    },
    on: {
      "on-row-click": function($event) {},
      "on-selection-change": _vm.onSelectionChange
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "500px"
    },
    model: {
      value: (_vm.modalConfirmMultipleDelete),
      callback: function($$v) {
        _vm.modalConfirmMultipleDelete = $$v
      },
      expression: "modalConfirmMultipleDelete"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#f60",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Konfirmasi")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._l((_vm.paymentsToDelete), function(paymentToDelete) {
    return _c('div', [_c('strong', [_vm._v(_vm._s(paymentToDelete.paymentDate) + " ")]), _vm._v(" "), _c('Tag', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("Rp " + _vm._s(_vm._f("numberFormatted")(paymentToDelete.amount)))]), _vm._v(" "), _c('br'), _vm._v(_vm._s(paymentToDelete.description) + "\n                    "), _c('br'), _c('br')], 1)
  }), _vm._v("\n\n                Total Pembayaran  "), _c('Tag', {
    attrs: {
      "color": "green"
    }
  }, [_vm._v("Rp " + _vm._s(_vm._f("numberFormatted")(_vm.totalPaymentToDelete)))])], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "error",
      "size": "large",
      "long": "",
      "loading": _vm.isLoadingDelete
    },
    on: {
      "click": function($event) {
        return _vm.deletePayments(_vm.paymentsToDelete)
      }
    }
  }, [_vm._v("Hapus")])], 1)])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentsToDelete.length > 0),
      expression: "paymentsToDelete.length > 0"
    }],
    staticClass: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "error",
      "loading": _vm.isLoadingDelete,
      "icon": "trash-a",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.modalConfirmMultipleDelete = true
      }
    }
  }, [_c('span', [_vm._v("Hapus " + _vm._s(_vm.paymentsToDelete.length) + " data")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59f9df33","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payment/PaymentDelete.vue
// module id = 1815
// module chunks = 1